export const GET_TASK_CARD_DATA_BEGIN = 'GET_TASK_CARD_DATA_BEGIN'
export const GET_TASK_CARD_DATA_SUCCESS = 'GET_TASK_CARD_DATA_SUCCESS'
export const GET_TASK_CARD_DATA_ERROR = 'GET_TASK_CARD_DATA_ERROR'

export const SEND_TASK_EMAIL_BEGIN = 'SEND_TASK_EMAIL_BEGIN'
export const SEND_TASK_EMAIL_SUCCESS = 'SEND_TASK_EMAIL_SUCCESS'
export const SEND_TASK_EMAIL_ERROR = 'SEND_TASK_EMAIL_ERROR'

export const SET_TASKCARD_FILTER_DATA = 'SET_TASKCARD_FILTER_DATA'